import Swiper from './vendor/swiper.custom';

window.Swiper = Swiper;
